const Section = ({ id, title, description, className = "", children }) => (
  <section id={id} className={`section ${className}`.trim()}>
    <div className="container">
      {title ? (
        <div className="section__header">
          <h2>{title}</h2>
          {description ? <p>{description}</p> : null}
        </div>
      ) : null}
      {children}
    </div>
  </section>
);

export default Section;
